import { Center, createStyles, Stack, Text as MantineText, ThemeIcon, Title } from '@mantine/core';
import { FC, ReactNode } from 'react';

const useStyles = createStyles((theme) => ({
  emptyState: {
    minHeight: 330,
    padding: `${theme.spacing.xl * 2}px ${theme.spacing.md}px`,
    textAlign: 'center',
  },

  emptyIcon: {
    color: theme.colorScheme === 'dark' ? theme.colors.blue[2] : theme.colors.blue[6],
    backgroundColor: theme.colorScheme === 'dark' ? theme.fn.rgba(theme.colors.blue[6], 0.14) : '#DFEBFB',
  },

  emptyTitle: {
    color: theme.colorScheme === 'dark' ? theme.white : theme.colors.dark[8],
  },
}));

interface Props {
  icon: ReactNode;
  title: string;
  children: ReactNode;
  maxWidth?: number;
}

const EmptyListState: FC<Props> = ({ icon, title, children, maxWidth = 360 }) => {
  const { classes } = useStyles();

  return (
    <Center className={classes.emptyState}>
      <Stack align="center" spacing="xs" maw={maxWidth}>
        <ThemeIcon className={classes.emptyIcon} size={56} radius="xl" variant="light" mb="sm">
          {icon}
        </ThemeIcon>
        <Title className={classes.emptyTitle} order={3} size={20}>
          {title}
        </Title>
        <MantineText color="dimmed" size="sm" sx={{ lineHeight: 1.6 }}>
          {children}
        </MantineText>
      </Stack>
    </Center>
  );
};

export default EmptyListState;
